/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TeamUserSummaryEntity } from './TeamUserSummaryEntity.js';
import {
    TeamUserSummaryEntityFromJSON,
    TeamUserSummaryEntityFromJSONTyped,
    TeamUserSummaryEntityToJSON,
} from './TeamUserSummaryEntity.js';
import type { UserPermission } from './UserPermission.js';
import {
    UserPermissionFromJSON,
    UserPermissionFromJSONTyped,
    UserPermissionToJSON,
} from './UserPermission.js';
import type { UserRole } from './UserRole.js';
import {
    UserRoleFromJSON,
    UserRoleFromJSONTyped,
    UserRoleToJSON,
} from './UserRole.js';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof User
     */
    role?: UserRole;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    dateCreated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    noSignIn?: boolean;
    /**
     * 
     * @type {Array<TeamUserSummaryEntity>}
     * @memberof User
     */
    teams?: Array<TeamUserSummaryEntity>;
    /**
     * 
     * @type {Array<UserPermission>}
     * @memberof User
     */
    permissions?: Array<UserPermission>;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): boolean {
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'role': json['role'] == null ? undefined : UserRoleFromJSON(json['role']),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'noSignIn': json['noSignIn'] == null ? undefined : json['noSignIn'],
        'teams': json['teams'] == null ? undefined : ((json['teams'] as Array<any>).map(TeamUserSummaryEntityFromJSON)),
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(UserPermissionFromJSON)),
    };
}

export function UserToJSON(value?: User | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'role': UserRoleToJSON(value['role']),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated'] as any).toISOString()),
        'noSignIn': value['noSignIn'],
        'teams': value['teams'] == null ? undefined : ((value['teams'] as Array<any>).map(TeamUserSummaryEntityToJSON)),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(UserPermissionToJSON)),
    };
}

